import { render, staticRenderFns } from "./SelectFallbackColumn.vue?vue&type=template&id=53d6e6fc"
import script from "./SelectFallbackColumn.vue?vue&type=script&lang=ts"
export * from "./SelectFallbackColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports